<template>
  <o-dialog
    ref="dialog"
    :title="$t('tax.bulkSet')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import type { Tax } from '~/_api/models/tax'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const tax = ref<Tax | null>(null)
const type = ref<string | null>(null)
const state = ref<boolean | null>(null)

const info = computed(() => {
  return $i18n.t(state.value ? 'components.tax.actions.bulkSet.enableInfo' : 'components.tax.actions.bulkSet.disableInfo', { name: tax.value?.name, type: type.value })
})

const open = (taxItem: Tax, typeValue: string, stateValue: boolean) => {
  tax.value = taxItem
  type.value = typeValue
  state.value = stateValue

  dialog.value.open()
}

const confirm = async () => {
  if (!tax.value || !type.value || state.value === null) return

  try {
    const success = await $api.tax.bulkSet(tax.value, type.value, state.value)

    if (success) {
      emit('update:loading', false)

      $notification.toast({
        title: $i18n.t('general.success'),
        text: $i18n.t(state.value ? 'components.tax.actions.bulkSet.enableSuccess' : 'components.tax.actions.bulkSet.disableSuccess', { name: tax.value.name, type: type.value }),
        variant: 'success',
      })

      return true
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

defineExpose({
  open,
})
</script>
